import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from '../axiosConfig';
import { rfidLocation } from './rfidLocation';

const formatTime = time => new Date(time).toLocaleString('en-IN', {
  day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Kolkata'
});

export default function WorkerAttendance({ employeeId }) {
  const [record, setRecord] = useState(null);
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(false);
  const locked = useRef(false);
  const version = useRef(0);
  const refresh = useCallback(async () => {
    if (locked.current) return;
    const current = ++version.current;
    try {
      const { data } = await api.get('/api/worker-attendance');
      if (current === version.current) setRecord(data);
    } catch {
      if (current === version.current) setRecord(null);
    }
  }, []);
  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, 15000);
    window.addEventListener('focus', refresh);
    window.addEventListener('wip-attendance-changed', refresh);
    return () => {
      version.current++;
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('wip-attendance-changed', refresh);
    };
  }, [refresh, employeeId]);
  async function punch(direction) {
    if (locked.current) return;
    if (direction === 'out' && !window.confirm('Punch out and finish attendance for today?')) return;
    locked.current = true;
    ++version.current;
    setBusy(true);
    setNotice('');
    try {
      const location = direction === 'in' ? await rfidLocation() : {};
      const { data } = await api.post('/api/mark-' + direction, location);
      setNotice(data.message);
      setRecord(data);
    } catch (error) {
      setNotice(error.response?.data?.error || 'Attendance could not be confirmed. Check your status before trying again.');
    } finally {
      locked.current = false;
      setBusy(false);
      refresh();
    }
  }
  return <section className="mt-2 text-end" aria-label="Worker attendance">
    {record?.punchIn && <small className="d-block text-muted mb-2" role="status">
      <span>{record.punchOut ? 'Punched out' : 'Punched in'}</span> · {formatTime(record.punchOut || record.punchIn)} IST
    </small>}
    <div className="d-flex justify-content-end gap-2"><button className="btn btn-success" disabled={busy || !record?.canPunchIn} onClick={() => punch('in')}>Punch In</button>
      <button className="btn btn-outline-danger" disabled={busy || !record?.canPunchOut} onClick={() => punch('out')}>Punch Out</button></div>
    {busy && <small role="status">Recording attendance…</small>}{notice && <small className="mt-2" role="status">{notice}</small>}
  </section>;
}
